var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTailwindcss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9062 0H21.0938C9.44399 0 0 9.44399 0 21.0938V68.9062C0 80.556 9.44399 90 21.0938 90H68.9062C80.556 90 90 80.556 90 68.9062V21.0938C90 9.44399 80.556 0 68.9062 0Z",
    fill: "#242938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1797 38.6719C31.2891 30.2344 36.5629 26.0156 45 26.0156C57.6562 26.0156 59.2383 35.5078 65.5664 37.0898C69.7855 38.1449 73.4766 36.5629 76.6406 32.3438C74.5316 40.7809 69.2575 45 60.8203 45C48.1641 45 46.582 35.5078 40.2539 33.9258C36.0348 32.8711 32.3438 34.4531 29.1797 38.6719ZM13.3594 57.6562C15.4688 49.2191 20.7422 45 29.1797 45C41.8359 45 43.418 54.4922 49.7461 56.0742C53.9652 57.1293 57.6562 55.5472 60.8203 51.3281C58.7113 59.7653 53.4371 63.9844 45 63.9844C32.3438 63.9844 30.7617 54.4922 24.4336 52.9102C20.2148 51.8551 16.5234 53.4371 13.3594 57.6562Z",
    fill: "url(#paint0_linear_153_190)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_153_190",
    x1: 30.4102,
    y1: 26.0156,
    x2: 57.4805,
    y2: 65.2148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32B1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14C6B7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.72f51645a1c917812ff3f3dc04c47500.svg";
export { ForwardRef as ReactComponent };